import React, { useEffect, useRef } from "react";

import { BurgerWrapper } from "../menu/styles.Menu";
import {
  DeepDiveWrapper,
  DeepDiveLinkLayout,
  Underline,
  Text,
  Overline,
  TextWrapper,
  ArrowWrapper,
  HeadlineWrapper,
} from "./styles.DeepDive";
import Arrow from "../../assets/arrow-right.svg";
import CloseIcon from "../../assets/Close-X.svg";

interface HeadlineProps {
  authorName: string;
}

export const Headline: React.FC<HeadlineProps> = ({ authorName, children }) => {
  return (
    <HeadlineWrapper>
      <h2>{children}</h2>
      <div>by {authorName}</div>
    </HeadlineWrapper>
  );
};

interface DeepDiveLinkProps {
  id?: number;
  backlink?: boolean;
  direction?: string;
  onClick?: any;
  backLinkColor?: string;
  backgroundColor: string;
  newBackgroundColor?: string;
}

export const DeepDiveLink: React.FC<DeepDiveLinkProps> = ({
  id,
  backlink,
  direction = "left",
  onClick,
  backLinkColor = "rgb(255, 255, 255, .35)",
  backgroundColor = "#fff",
  newBackgroundColor = offsetColor(backgroundColor),
  children,
}) => {
  return (
    <DeepDiveLinkLayout
      direction={direction}
      onClick={() =>
        onClick(id, direction, newBackgroundColor, backgroundColor, backlink)
      }
    >
      <TextWrapper direction={direction}>
        {!backlink ? <Overline>DeepDive:</Overline> : undefined}

        <ArrowWrapper direction={direction}>
          {direction == "left" ? (
            <img className="arrow arrowLeft" src={Arrow} alt="Arrow" />
          ) : undefined}
          <Text>{children}</Text>
          {direction == "right" ? (
            <img className="arrow arrowRight" src={Arrow} alt="Arrow" />
          ) : undefined}
        </ArrowWrapper>
      </TextWrapper>
      <Underline direction={direction} color={backLinkColor}></Underline>
    </DeepDiveLinkLayout>
  );
};

interface DeepDiveProps {
  position: string;
  preventScroll: boolean;
}

export const DeepDive: React.FC<DeepDiveProps> = ({
  position,
  preventScroll,
  children,
}) => {
  const deepDiveRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (deepDiveRef.current && !preventScroll) {
      deepDiveRef.current.scrollTo(0, 0);
    }
  });

  return (
    <DeepDiveWrapper ref={deepDiveRef} position={position}>
      {children}
    </DeepDiveWrapper>
  );
};

export const DeepDiveCloseButton: React.FC<DeepDiveLinkProps> = ({
  id,
  backlink,
  direction = "left",
  onClick,
  backgroundColor = "#fff",
  newBackgroundColor = offsetColor(backgroundColor),
}) => {
  return (
    <BurgerWrapper
      onClick={() =>
        onClick(id, direction, newBackgroundColor, backgroundColor, backlink)
      }
    >
      <img src={CloseIcon} alt="Close deep dive" />
    </BurgerWrapper>
  );
};

function offsetColor(backgroundColor: string) {
  let opacity: number = 0.35;

  let colorValues: Array<string> = [];

  for (let i = 1; i < 7; i = i + 2) {
    let colorValueDec: number = parseInt(backgroundColor.slice(i, i + 2), 16);
    let colorValueLightDec: number = Math.trunc(
      colorValueDec * opacity + (1 - opacity) * 255
    );
    let colorValueLightHex: string = colorValueLightDec.toString(16);
    colorValues.push(colorValueLightHex);
  }

  return "#" + colorValues.join("");
}
